function scroll_to_step01() {
  $('.program-carousel-vertical').animate({ scrollTop: 0 }, 'slow');
}

function scroll_to_step02() {
  let h_step01 = $('#step01').outerHeight();
  let h_step02 = h_step01 + $('#step02').outerHeight();
  let h_step03 = h_step02 + $('#step03').outerHeight();
  let h_step04 = h_step03 + $('#step04').outerHeight();
  let h_step05 = h_step04 + $('#step05').outerHeight();
  $('.program-carousel-vertical').animate({ scrollTop: h_step01 }, 'slow');
}

function scroll_to_step03() {
  let h_step01 = $('#step01').outerHeight();
  let h_step02 = h_step01 + $('#step02').outerHeight();
  let h_step03 = h_step02 + $('#step03').outerHeight();
  let h_step04 = h_step03 + $('#step04').outerHeight();
  let h_step05 = h_step04 + $('#step05').outerHeight();
  $('.program-carousel-vertical').animate({ scrollTop: h_step02 }, 'slow');
}

function scroll_to_step04() {
  let h_step01 = $('#step01').outerHeight();
  let h_step02 = h_step01 + $('#step02').outerHeight();
  let h_step03 = h_step02 + $('#step03').outerHeight();
  let h_step04 = h_step03 + $('#step04').outerHeight();
  let h_step05 = h_step04 + $('#step05').outerHeight();
  $('.program-carousel-vertical').animate({ scrollTop: h_step03 }, 'slow');
}

function scroll_to_step05() {
  let h_step01 = $('#step01').outerHeight();
  let h_step02 = h_step01 + $('#step02').outerHeight();
  let h_step03 = h_step02 + $('#step03').outerHeight();
  let h_step04 = h_step03 + $('#step04').outerHeight();
  let h_step05 = h_step04 + $('#step05').outerHeight();
  $('.program-carousel-vertical').animate({ scrollTop: h_step04 }, 'slow');
}

function scroll_to_step06() {
  let h_step01 = $('#step01').outerHeight();
  let h_step02 = h_step01 + $('#step02').outerHeight();
  let h_step03 = h_step02 + $('#step03').outerHeight();
  let h_step04 = h_step03 + $('#step04').outerHeight();
  let h_step05 = h_step04 + $('#step05').outerHeight();
  $('.program-carousel-vertical').animate({ scrollTop: h_step05 }, 'slow');
}

document.addEventListener('DOMContentLoaded', () => {
  $('#carousel-button1').click(function () {
    scroll_to_step01();
  });

  $('#carousel-button2').click(function () {
    scroll_to_step02();
  });

  $('#carousel-button3').click(function () {
    scroll_to_step03();
  });

  $('#carousel-button4').click(function () {
    scroll_to_step04();
  });

  $('#carousel-button5').click(function () {
    scroll_to_step05();
  });

  $('#carousel-button6').click(function () {
    scroll_to_step06();
  });

  $('.program-carousel-vertical').scroll(function () {
    let h_step01 = $('#step01').outerHeight();
    let h_step02 = h_step01 + $('#step02').outerHeight();
    let h_step03 = h_step02 + $('#step03').outerHeight();
    let h_step04 = h_step03 + $('#step04').outerHeight();
    let h_step05 = h_step04 + $('#step05').outerHeight();
    let h_step06 = h_step05 + $('#step06').outerHeight();

    if ($('.program-carousel-vertical').scrollTop() <= h_step01 - 75) {
      $('.programme-button').removeClass('active');
      $('#carousel-button1').addClass('active');
    } else if (
      $('.program-carousel-vertical').scrollTop() > h_step01 - 75 &&
      $('.program-carousel-vertical').scrollTop() <= h_step02 - 75
    ) {
      $('.programme-button').removeClass('active');
      $('#carousel-button2').addClass('active');
    } else if (
      $('.program-carousel-vertical').scrollTop() > h_step02 - 75 &&
      $('.program-carousel-vertical').scrollTop() <= h_step03 - 75
    ) {
      $('.programme-button').removeClass('active');
      $('#carousel-button3').addClass('active');
    } else if (
      $('.program-carousel-vertical').scrollTop() > h_step03 - 75 &&
      $('.program-carousel-vertical').scrollTop() <= h_step04 - 75
    ) {
      $('.programme-button').removeClass('active');
      $('#carousel-button4').addClass('active');
    } else if (
      $('.program-carousel-vertical').scrollTop() > h_step04 - 75 &&
      $('.program-carousel-vertical').scrollTop() <= h_step05 - 75
    ) {
      $('.programme-button').removeClass('active');
      $('#carousel-button5').addClass('active');
    } else if ($('.program-carousel-vertical').scrollTop() > h_step05 - 75) {
      $('.programme-button').removeClass('active');
      $('#carousel-button6').addClass('active');
    } else return;
  });
});
